import {useState, useEffect} from 'react'
import {useHasRequiredRecords} from '~/hooks'

export const useFetchSearch = ({searchQuery, requiredRecords, model}) => {
	const hasRequiredRecords = useHasRequiredRecords(requiredRecords)
	const [isLoading, setIsLoading] = useState(false)
	const [recordIds, setRecordIds] = useState([])

	useEffect(() => {
		if (!searchQuery) return setRecordIds([])

		const fetchData = async () => {
			setIsLoading(true)
			const response = await model.arbitrary(`search?term=${searchQuery}`, {}, {method: 'post', extraParams: {doNotLoad: true}})
			const items = response?.data?.items

			response.ok && items ? setRecordIds(items._map('id')) : setRecordIds([])
			setIsLoading(false)
		}
		fetchData()
	}, [searchQuery])

	const searchResults = model.useWhere(recordIds, {joins: requiredRecords})

	return {searchResults, isLoading: !hasRequiredRecords || isLoading}
}
